<template>
  <section class="content">
    <admin-header
      :title="'Currencies'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:entity-quick-search="search"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:csv-upload="multiSave"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    name: 'AdminCurrency',
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    data () {
      return {
        newEntityScreen: 'Admin - Currencies',
        searchEntityScreen: 'Admin - Currency search',
        filterEventName: 'admin-currency-filter',
        filterName: 'CurrencyFilter',
        entityName: 'currency'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Currency/AdminCurrency.vue